import { Component, ViewChild, HostListener } from '@angular/core'

import dTree from 'd3-dtree/dist/dTree'

import { UsersService } from '../../services/users.service'
import { User, Sex } from '../../models/user.model'
import { Relationship, RelationshipType } from '../../models/relationship.model'

import * as moment from 'moment'
moment.locale('fr')

@Component({
  selector: 'ld-trees',
  template: require('./trees.component.html'),
  styles: [require('./trees.component.css')]
})
export class TreesComponent {
  @ViewChild('container') container
  @ViewChild('graph') graph
  private trees

  constructor (
    private usersService: UsersService) {
  }

  async ngOnInit () {
    this.trees = await this.usersService.getTrees()
    this.renderTrees(this.formatTrees(this.trees))
  }

  formatTrees (trees) {
    return trees
      // some marriages have been ignored on api side, returning null
      .filter(marriage => marriage)
      .map(tree => {
        // root sex
        tree.class = this.formatSexCss(tree.extra.sex)

        // root dob & dop
        if (tree.extra.dob) tree.name += '<br /><span class="dob">' + moment.utc(tree.extra.dob).format('DD/MM/YYYY') + '</span>'
        if (tree.extra.dop) {
          tree.class += ' death'
          tree.name += '<br /><span class="dop">' + moment.utc(tree.extra.dop).format('DD/MM/YYYY') + '</span>'
        }

        // copy node for searching
        tree.extra.node = tree

        // mariages
        tree.marriages.map(marriage => {
          // sex
          marriage.spouse.class = this.formatSexCss(marriage.spouse.extra.sex)

          // root dob & dop
          if (marriage.spouse.extra.dob) marriage.spouse.name += '<br /><span class="dob">' + moment.utc(marriage.spouse.extra.dob).format('DD/MM/YYYY') + '</span>'
          if (marriage.spouse.extra.dop) {
            marriage.spouse.class += ' death'
            marriage.spouse.name += '<br /><span class="dop">' + moment.utc(marriage.spouse.extra.dop).format('DD/MM/YYYY') + '</span>'
          }

          // other children (from another marriage)
          if (marriage.spouse.extra.otherChild) {
            marriage.spouse.class += ' otherChild'
          }

          // relationship
          tree.class += ` ${marriage.spouse.extra.relationship}`

          // copy node in extra for searching
          marriage.spouse.extra.node = tree

          // recursive on children
          marriage.children = this.formatTrees(marriage.children)
        })

        return tree
      })
  }

  formatSexCss (label) {
    switch (label) {
      case Sex[Sex.F]:
        return 'woman'
      case Sex[Sex.M]:
        return 'man'
      case Sex[Sex.O]:
      default:
        return 'other'
    }
  }

  sortNodes (extraA, extraB) {
    // Members without birth date are displayed before
    if (!extraA.dob && extraB.dob) return -1
    else if (extraA.dob && !extraB.dob) return 1
    // Order from older to younger
    else return moment.utc(extraA.dob).isBefore(moment.utc(extraB.dob)) ? -1 : 1
  }

  renderTrees (tree) {
    // reset graph
    if (this.graph.nativeElement.lastChild) {
      this.graph.nativeElement.removeChild(this.graph.nativeElement.lastChild)
    }
    // Root nodes need to be sorted first
    tree.sort((rootA, rootB) => this.sortNodes(rootA.extra, rootB.extra))

    // render
    dTree.init(tree, {
      target: this.graph.nativeElement,
      height: '8', // 80%
      width: this.container.nativeElement.clientWidth,
      callbacks: {
        nodeClick: (name, extra) => this.showUserTree(extra.id),
        nodeSorter: (nameA, extraA, nameB, extraB) => this.sortNodes(extraA, extraB)
      },
      margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      nodeWidth: 200
    })
  }

  async showUserTree (id: string) {
    this.trees = await this.usersService.getTrees(id)
    this.renderTrees(this.formatTrees(this.trees))
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/trees/trees.component.ts